<template>
  <v-container
    fluid
    grid-list-md
    v-if="
      isLoggedIn &&
      (role.indexOf('Global Support Manager') > -1 ||
        role.indexOf('Broker Support Admin') > -1) &&
      role.indexOf('Broker Plan Manager') == -1 &&
      role.indexOf('Broker Plan Admin') == -1 &&
      role.indexOf('Employer Plan Admin') == -1 &&
      role.indexOf('Employer Members Viewer') == -1 &&
      role.indexOf('Employer Billing Viewer') == -1 &&
      role.indexOf('Employer Premiums Viewer') == -1
    "
  >
    <v-layout row wrap>
      <material-stats-card
        v-if="isLoggedIn && role.indexOf('Global Support Manager') > -1"
        :color="$vuetify.theme.themes.light.secondary"
        icon="badge"
        :value="$t('components.getreports.brokers')"
      >
        <template slot="actions">
          <v-btn
            text
            color="primary"
            @click="$router.push({ name: 'brokers' })"
          >
            {{ $t("views.members.manage") }}
          </v-btn>
        </template>
      </material-stats-card>

      <material-stats-card
        :color="$vuetify.theme.themes.light.secondary"
        icon="people"
        :value="$t('components.vuematerialdashboard.core.appbar.users')"
      >
        <template slot="actions">
          <v-btn text color="primary" @click="$router.push({ name: 'users' })">
            {{ $t("views.members.manage") }}
          </v-btn>
        </template>
      </material-stats-card>

      <material-stats-card
        :color="$vuetify.theme.themes.light.secondary"
        icon="label"
        :value="$t('components.vuematerialdashboard.core.appbar.tags')"
      >
        <template slot="actions">
          <v-btn text color="primary" @click="$router.push({ name: 'tags' })">
            {{ $t("views.members.manage") }}
          </v-btn>
        </template>
      </material-stats-card>

      <material-stats-card
        :color="$vuetify.theme.themes.light.secondary"
        icon="help"
        :value="$t('components.vuematerialdashboard.core.appbar.help')"
      >
        <template slot="actions">
          <v-btn text color="primary" @click="$router.push({ name: 'help' })">
            {{ $t("views.dashboard.navigate") }}
          </v-btn>
        </template>
      </material-stats-card>
    </v-layout>
  </v-container>
  <v-container
    fluid
    grid-list-md
    v-else-if="
      planOptions &&
      selectedPlan !== null &&
      selectedPlan !== undefined &&
      isLoggedIn &&
      (role.indexOf('Broker Plan Admin') > -1 ||
        role.indexOf('Broker Plan Manager') > -1 ||
        role.indexOf('Employer Plan Admin') > -1 ||
        role.indexOf('Documents Management Admin') > -1 ||
        role.indexOf('Employer Members Viewer') > -1 ||
        role.indexOf('Employer Billing Viewer') > -1 ||
        role.indexOf('Employer Premiums Viewer') > -1 ||
        role.indexOf('Member Portal Admin') > -1 ||
        role.indexOf('Member Portal Users Admin') > -1)
    "
  >
    <v-dialog v-model="sickDayWarning" scrollable persistent max-width="400">
      <material-card
        :title="$t('globals.warning')"
        :color="$vuetify.theme.themes.light.warning"
        icon="science"
      >
        <v-card-text>
          {{ $t("views.members.sick_day_warning_message") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="sickDayWarning = false">
            {{ $t("globals.ok") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <div v-for="(category, index) in categories" v-bind:key="index">
      <v-layout row wrap v-if="!category.vif || category.vif.call(this)">
        <v-card-title>
          <v-icon>{{ category.icon }}</v-icon>
          <h4>{{ $t(category.title) }}</h4>
        </v-card-title>
      </v-layout>
      <v-layout row wrap v-if="!category.vif || category.vif.call(this)">
        <div v-for="(item, index) in category.tiles" v-bind:key="index">
          <material-stats-card
            :color="$vuetify.theme.themes.light.secondary"
            :icon="item.icon"
            :value="$t(item.title)"
            v-if="!item.vif || item.vif.call(this)"
          >
            <template slot="actions">
              <div class="d-flex justify-center flex-wrap">
                <v-menu offset-y v-if="item.isMenu">
                  <template v-slot:activator="{ on }">
                    <v-btn slot="activator" color="primary" v-on="on" text>
                      {{ $t(item.menuTitle) }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(button, index) in item.buttons.filter(
                        (o) => !o.vif || o.vif.call(this)
                      )"
                      v-bind:key="index"
                      @click="button.action.call(this)"
                    >
                      <v-list-item-title>
                        {{ $t(button.title) }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <template v-else>
                  <template v-for="(button, index) in item.buttons">
                    <template v-if="button.actions">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            slot="activator"
                            color="primary"
                            v-on="on"
                            text
                          >
                            {{ $t(button.title) }}
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="(action, index) in button.actions.filter(
                              (o) => !o.vif || o.vif.call(this)
                            )"
                            v-bind:key="index"
                            @click="action.action.call(this)"
                          >
                            <v-list-item-title>
                              {{ $t(action.title) }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                    <template v-else>
                      <v-btn
                        v-if="!button.vif || button.vif.call(this)"
                        v-bind:key="index"
                        text
                        color="primary"
                        @click="button.action.call(this)"
                      >
                        {{ $t(button.title) }}
                      </v-btn>
                    </template>
                  </template>
                </template>
              </div>
            </template>
          </material-stats-card>
        </div>
      </v-layout>
    </div>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { planSetter } from "../mixins/planSetter";
import SettingsService from "@/services/settings.service.js";
export default {
  props: ["generalSettings"],
  data() {
    return {
      payload: {
            Json: {},
          },
      broker: null,
      categories: [
        {
          title: "globals.plan",
          icon: "insert_drive_file",
          tiles: [
            {
              vif: () =>
                this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Broker Plan Admin") > -1,
              title: "components.plancreationwizard.general_settings",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "perm_data_setting",
              buttons: [
                {
                  title: "views.dashboard.view",
                  action: () => {
                    this.$router.push({
                      name: "planGeneralParameters",
                      params: { planId: this.selectedPlan.Id, edit: true },
                    });
                  },
                },
                // {
                //   title: "views.planparameters.renew",
                //   action: () => {
                //     this.$router.push({
                //       name: "planRenewWizard"
                //     });
                //   }
                // }
              ],
            },
            {
              title: "views.planparameters.trust_fund",
              vif: () => {
                // console.log(this.planIdentity);
                return (
                  (this.planIdentity.PlanType === "HW" ||
                    this.planIdentity.PlanType === "Pension") &&
                  this.planIdentity.TrustFund &&
                  this.role.indexOf("Broker Plan Manager") > -1
                );
              },
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "business",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "trustFund",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "globals.insurance_carriers",
              vif: () => {
                return (
                  this.planIdentity.PlanType === "HW" &&
                  this.planOptions.HasPremiums &&
                  this.role.indexOf("Broker Plan Manager") > -1
                );
              },
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "home_work",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "insuranceCarriers",
                      params: { planId: this.selectedPlan.Id, edit: true },
                    });
                  },
                },
              ],
            },
            {
              vif: () =>
                (this.planIdentity.PlanType === "HW" ||
                  this.planIdentity.PlanType === "Pension") &&
                this.role.indexOf("Broker Plan Manager") > -1,
              title: "globals.coverage",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "policy",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "coverage",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              vif: () => this.planIdentity.PlanType === "Pension",
              title: "views.unionlocals.union_locals",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "mdi-lan",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "unionLocals",
                      params: { planId: this.selectedPlan.Id, edit: true },
                    });
                  },
                },
              ],
            },
          ],
          vif: () =>
            (this.isLoggedIn &&
              this.role.indexOf("Broker Plan Manager") > -1) ||
            (this.isLoggedIn && this.role.indexOf("Broker Plan Admin") > -1) ||
            (this.isLoggedIn && this.role.indexOf("Broker Plan Creator") > -1),
        },
        {
          title: "components.membersmanagementtable.members",
          icon: "assignment_ind",
          tiles: [
            {
              title: "views.members.member_record",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "folder_shared",
              buttons: [
                {
                  title: "globals.add_new",
                  vif: () =>
                    this.role.indexOf("Broker Plan Manager") > -1 ||
                    this.role.indexOf("Broker Plan Admin") > -1 ||
                    this.role.indexOf("Employer Plan Admin") > -1,
                  action: () => {
                    this.$router.push({
                      name: "addMemberWizard",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "views.members.find_and_edit",
                  action: () => {
                    this.$router.push({
                      name: "searchMembersForm",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "views.members.beneficiaries_record",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "folder_shared",
              buttons: [
                {
                  title: "views.members.find_and_edit",
                  action: () => {
                    this.$router.push({
                      name: "searchBeneficiariesForm",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
              vif: () =>
                this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Broker Plan Admin") > -1,
            },
            {
              title: "views.members.members_list",
              vif: () =>
                this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Broker Plan Admin") > -1 ||
                this.role.indexOf("Employer Plan Admin") > -1 ||
                this.role.indexOf("Employer Members Viewer") > -1,
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "reduce_capacity",
              buttons: [
                {
                  title: "components.claims_history.view_all",
                  action: () => {
                    this.$router.push({
                      name: "membersManagement",
                      params: { planId: this.selectedPlan.Id, edit: true },
                    });
                  },
                },
                {
                  title: "views.members.bulk_update",
                  action: () => {
                    this.$router.push({
                      name: "membersImportSalaries",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                  vif: () =>
                    this.role.indexOf("Broker Plan Manager") > -1 ||
                    this.role.indexOf("Broker Plan Admin") > -1 ||
                    this.role.indexOf("Employer Plan Admin") > -1,
                },
              ],
            },
            {
              title: "views.members.member_hours",
              vif: () =>
                this.planIdentity &&
                this.planIdentity.TrackHours &&
                (this.role.indexOf("Broker Plan Manager") > -1 ||
                  this.role.indexOf("Employer Plan Admin") > -1),
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "publish",
              buttons: [
                {
                  title: "views.members.tasks",
                  action: () => {
                    this.$router.push({
                      name: "pendingHoursTasksTable",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "views.members.bulk_update",
                  action: this.bulkHoursClick,
                },
              ],
            },
            {
              title: "components.plancreationwizard.eligibility_bank",
              vif: () =>
                this.planIdentity &&
                this.planIdentity.HasEligibilityBank &&
                (this.role.indexOf("Broker Plan Manager") > -1 ||
                  this.role.indexOf("Employer Plan Admin") > -1),
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "account_balance",
              buttons: [
                {
                  title: "views.members.tasks",
                  action: () => {
                    this.$router.push({
                      name: "eligibilityHourBankEvaluations",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "views.members.select_wizard",
                  actions: [
                    {
                      title: "views.members.evaluation_wizard",
                      action: () => {
                        this.$router.push({
                          name: "evaluateEligibilityHourBankWizard",
                          params: { planId: this.selectedPlan.Id },
                        });
                      },
                    },
                    {
                      title: "views.members.reevaluation_wizard",
                      action: () => {
                        this.$router.push({
                          name: "reevaluateEligibilityHourBankWizard",
                          params: { planId: this.selectedPlan.Id },
                        });
                      },
                    },
                    {
                      title: "components.memberview.credit_hours",
                      action: () => {
                        this.$router.push({
                          name: "eligibilityBankCreditHours",
                          params: { planId: this.selectedPlan.Id },
                        });
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: "views.members.pending_self_payments",
              vif: () =>
                this.planIdentity.IncludeSelfPayments &&
                (this.role.indexOf("Broker Plan Manager") > -1 ||
                  this.role.indexOf("Broker Plan Admin") > -1),
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "payments",
              isMenu: true,
              menuTitle: "globals.select",
              buttons: [
                {
                  title: "globals.all",
                  action: () => {
                    this.$router.push({
                      name: "pendingSelfPayments",
                      params: {
                        planId: this.selectedPlan.Id,
                        deposited: "all",
                      },
                    });
                  },
                },
                {
                  title: "headers.selfpayments.deposited",
                  action: () => {
                    this.$router.push({
                      name: "pendingSelfPayments",
                      params: {
                        planId: this.selectedPlan.Id,
                        deposited: "deposited",
                      },
                    });
                  },
                },
                {
                  title: "headers.selfpayments.non_deposited",
                  action: () => {
                    this.$router.push({
                      name: "pendingSelfPayments",
                      params: {
                        planId: this.selectedPlan.Id,
                        deposited: "non-deposited",
                      },
                    });
                  },
                },
              ],
            },
            {
              title: "views.members.data_import",
              vif: () =>
                this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Broker Plan Admin") > -1,
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "publish",
              isMenu: true,
              menuTitle: "views.members.select_wizard",
              buttons: [
                {
                  title: "components.membersmanagementtable.members",
                  action: () => {
                    this.$router.push({
                      name: "membersImportWizard",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "globals.dependants",
                  action: () => {
                    this.$router.push({
                      name: "dependantsImportWizard",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                  vif: () => this.selectedPlan.PlanType === "HW",
                },
                {
                  title: "components.memberview.contact_information",
                  action: () => {
                    this.$router.push({
                      name: "contactInformationImportWizard",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "components.memberview.employment_information",
                  action: () => {
                    this.$router.push({
                      name: "employmentInformationImportWizard",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "views.members.union_local_membership",
                  action: () => {
                    this.$router.push({
                      name: "unionLocalMembershipImportWizard",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                  vif: () => this.selectedPlan.PlanType === "Pension",
                },
                {
                  title: "components.memberview.hsa_credit",
                  action: () => {
                    this.$router.push({
                      name: "hsaImportWizard",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                  vif: () => this.planIdentity.HasHSA,
                },
              ],
            },
          ],
          vif: () =>
            (this.planIdentity.PlanType === "HW" ||
              this.planIdentity.PlanType === "Pension") &&
            this.isLoggedIn &&
            (this.role.indexOf("Broker Plan Manager") > -1 ||
              this.role.indexOf("Broker Plan Admin") > -1 ||
              this.role.indexOf("Employer Plan Admin") > -1 ||
              this.role.indexOf("Employer Members Viewer") > -1),
        },
        {
          title: "globals.employers",
          icon: "work",
          tiles: [
            {
              title: "views.employers_view.employer_record",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "work",
              buttons: [
                {
                  title: "globals.add_new",
                  action: () => {
                    this.$router.push({
                      name: "employerWizard",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "views.members.find_and_edit",
                  action: () => {
                    this.$router.push({
                      name: "searchEmployersForm",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                  vif: () => {
                    !this.selectedPlan.Current.IsTesting;
                  },
                },
              ],
            },
            {
              title: "views.employers_view.employers_list",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "cases",
              buttons: [
                {
                  title: "components.claims_history.view_all",
                  action: () => {
                    this.$router.push({
                      name: "employersView",
                      params: { planId: this.selectedPlan.Id, edit: true },
                    });
                  },
                },
              ],
            },
            {
              title: "headers.hourshistory.employer_contribution_term",
              vif: () =>
                this.planOptions.HasBilling &&
                this.planIdentity &&
                this.planIdentity.TrackHours,
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "date_range",
              buttons: [
                {
                  title: "globals.setup",
                  action: () => {
                    this.$router.push({
                      name: "contributionsSetup",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "views.members.data_import",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "publish",
              buttons: [
                {
                  title: "globals.employers",
                  action: () => {
                    this.$router.push({
                      name: "wip",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "globals.stores",
                  action: () => {
                    this.$router.push({
                      name: "wip",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
          ],
          vif: () =>
            this.isLoggedIn &&
            // this.planIdentity.PlanType === "HW" &&
            (this.role.indexOf("Broker Plan Admin") > -1 ||
              this.role.indexOf("Broker Plan Manager") > -1),
        },
        {
          title:
            "components.vuematerialdashboard.core.drawer.contributions_control",
          icon: "attach_money",
          tiles: [
            {
              title: "views.billing.calculation_wizard",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "assistant",
              buttons: [
                {
                  title: "views.billing.run",
                  action: () => {
                    this.$router.push({
                      name: "billingWizard",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                // {
                //   title: "globals.revise",
                //   action: () => {
                //     this.$router.push({
                //       name: "reviseWizard",
                //       params: { planId: this.selectedPlan.Id },
                //     });
                //   },
                // },
              ],
              vif: () => {
                return this.role.indexOf("Broker Plan Manager") > -1;
              },
            },
            {
              title: "views.contributions.employer_submissions",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "mediation",
              buttons: [
                {
                  title: "globals.import",
                  action: () => {
                    this.$router.push({
                      name: "contributionsWizard",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "globals.view",
                  action: () => {
                    this.$router.push({
                      name: "contributionsView",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
              vif: () =>
                this.planOptions.HasBillingImport &&
                (this.role.indexOf("Broker Plan Manager") > -1 ||
                  this.role.indexOf("Broker Plan Admin") > -1),
            },
            {
              title: "views.billing.billing_history",
              vif: () => {
                return (
                  this.planOptions.HasBilling &&
                  (this.role.indexOf("Broker Plan Manager") > -1 ||
                    this.role.indexOf("Broker Plan Admin") > -1 ||
                    this.role.indexOf("Employer Plan Admin") > -1 ||
                    this.role.indexOf("Employer Billing Viewer") > -1)
                );
              },
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "card_membership",
              buttons: [
                {
                  title: "views.billing.archive",
                  action: () => {
                    this.$router.push({
                      name: "billingArchive",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "views.billing.premiums_history",
              vif: () => {
                // console.log(this.planOptions);
                return (
                  this.planOptions.HasPremiums &&
                  (this.role.indexOf("Broker Plan Manager") > -1 ||
                    this.role.indexOf("Broker Plan Admin") > -1 ||
                    this.role.indexOf("Employer Premiums Viewer") > -1)
                );
              },
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "local_parking",
              buttons: [
                {
                  title: "views.billing.records",
                  action: () => {
                    this.$router.push({
                      name: "premiumsStatusTable",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "views.billing.archive",
                  action: () => {
                    this.$router.push({
                      name: "premiumsArchive",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "views.billing.remittances_history",
              vif: () => {
                return (
                  this.planOptions.HasRemittances &&
                  (this.role.indexOf("Broker Plan Manager") > -1 ||
                    this.role.indexOf("Broker Plan Admin") > -1)
                );
              },
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "account_balance",
              buttons: [
                {
                  title: "views.billing.records",
                  action: () => {
                    this.$router.push({
                      name: "remittancesHistory",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "views.billing.archive",
                  action: () => {
                    this.$router.push({
                      name: "remittancesArchive",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "views.billing.commissions_history",
              vif: () => {
                return (
                  this.planOptions.HasCommissions &&
                  (this.role.indexOf("Broker Plan Manager") > -1 ||
                    this.role.indexOf("Broker Plan Admin") > -1)
                );
              },
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "account_balance_wallet",
              buttons: [
                {
                  title: "views.billing.records",
                  action: () => {
                    this.$router.push({
                      name: "commissionsTable",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "views.billing.archive",
                  action: () => {
                    this.$router.push({
                      name: "commissionsArchive",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
          ],
          vif: () =>
            this.isLoggedIn &&
            this.planIdentity.PlanType === "HW" &&
            (this.role.indexOf("Broker Plan Manager") > -1 ||
              this.role.indexOf("Broker Plan Admin") > -1 ||
              this.role.indexOf("Employer Plan Admin") > -1 ||
              this.role.indexOf("Employer Billing Viewer") > -1 ||
              this.role.indexOf("Employer Premiums Viewer") > -1),
        },
        {
          title: "components.vuematerialdashboard.core.drawer.balance_payments",
          icon: "account_balance_wallet",
          tiles: [
            // {
            //   title: "views.balancepayments.balance",
            //   color: this.$vuetify.theme.themes.light.secondary,
            //   icon: "account_balance_wallet",
            //   buttons: [
            //     {
            //       title: "globals.view",
            //       action: () => {
            //         this.$router.push({
            //           name: "balanceView",
            //           params: { planId: this.selectedPlan.Id },
            //         });
            //       },
            //     },
            //   ],
            //   vif: () =>
            //     this.role.indexOf("Broker Plan Manager") > -1 ||
            //     this.role.indexOf("Broker Plan Admin") > -1,
            // },
            {
              title: "globals.payments",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "payments",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "paymentsView",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
              vif: () =>
                this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Broker Plan Admin") > -1,
            },
            {
              title: "views.invoices_view.invoices",
              color: "#64ba5f",
              icon: "list",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "invoicesView",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
              vif: () =>
                this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Broker Plan Admin") > -1,
            },
          ],
          vif: () =>
            this.planIdentity.PlanType === "HW" &&
            (this.role.indexOf("Broker Plan Manager") > -1 ||
              this.role.indexOf("Broker Plan Admin") > -1),
        },
        {
          title: "components.vuematerialdashboard.core.drawer.reporting",
          vif: () => {
            return (
              this.planIdentity.PlanType === "HW" &&
              (this.planOptions.HasT4A || this.planOptions.HasDemographics) &&
              (this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Broker Plan Admin") > -1)
            );
          },
          icon: "insert_chart",
          tiles: [
            {
              title: "views.reports.t4a",
              vif: () => {
                return this.planOptions.HasT4A;
              },
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "post_add",
              buttons: [
                {
                  title: "views.reports.run_wizard",
                  action: () => {
                    this.$router.push({
                      name: "t4aWizard",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "views.billingwizard.archive",
                  action: () => {
                    this.$router.push({
                      name: "t4aArchive",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "views.demographics.demographics",
              vif: () => {
                return this.planOptions.HasDemographics;
              },
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "pie_chart",
              buttons: [
                {
                  title: "views.dashboard.navigate",
                  action: () => {
                    this.$router.push({
                      name: "demographics",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "views.billingwizard.archive",
                  action: () => {
                    this.$router.push({
                      name: "demographicsArchive",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "components.plancreationwizard.eligibility",
              vif: () => {
                return this.planOptions.HasDemographics;
              },
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "verified_user",
              buttons: [
                {
                  title: "globals.select",
                  action: () => {
                    this.$router.push({
                      name: "eligibility",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
                {
                  title: "globals.select",
                  actions: [
                    {
                      title: "views.members.minimum_hour_bank_report",
                      action: () => {
                        this.$router.push({
                          name: "eligibilityBankMinimumHourReport",
                          params: { planId: this.selectedPlan.Id },
                        });
                      },
                    },
                    {
                      title: "views.reports.self_pay_report",
                      action: () => {
                        this.$router.push({
                          name: "wip",
                        });
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: "components.drawer.documents_center",
          vif: () =>
            this.role.indexOf("Broker Plan Manager") > -1 ||
            this.role.indexOf("Broker Plan Admin") > -1 ||
            this.role.indexOf("Employer Plan Admin") > -1 ||
            this.role.indexOf("Documents Management Admin") > -1 ||
            this.role.indexOf("Employer Members Viewer") > -1,
          icon: "topic",
          tiles: [
            {
              vif: () => {
                return (
                  this.planIdentity.HasDrupalPortal &&
                  this.planIdentity.MembersPortal &&
                  this.planIdentity.MembersPortal.IsActive &&
                  (this.role.indexOf("Broker Plan Admin") > -1 ||
                    this.role.indexOf("Employer Plan Admin") > -1 ||
                    this.role.indexOf("Broker Plan Manager") > -1 ||
                    this.role.indexOf("Documents Management Admin") > -1 ||
                    this.role.indexOf("Employer Members Viewer") > -1)
                );
              },
              title: "components.drawer.plan_files",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "topic",
              buttons: [
                {
                  title: "views.reports.view_&_download",
                  action: () => {
                    this.$router.push({
                      name: "adminFiles",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              vif: () => {
                return (
                  (!this.planIdentity.MembersPortal ||
                    this.planIdentity.PlanType === "NoManaged") &&
                  (this.role.indexOf("Broker Plan Admin") > -1 ||
                    this.role.indexOf("Employer Plan Admin") > -1 ||
                    this.role.indexOf("Broker Plan Manager") > -1 ||
                    this.role.indexOf("Employer Members Viewer") > -1 ||
                    this.role.indexOf("Documents Management Admin") > -1)
                );
              },
              title: "components.drawer.plan_files",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "topic",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "planFiles",
                      params: { planId: this.selectedPlan.Id, mode: "plan" },
                    });
                  },
                },
              ],
            },
            {
              vif: () => {
                return (
                  this.useDocumentsManagement &&
                  (this.role.indexOf("Broker Plan Admin") > -1 ||
                    this.role.indexOf("Employer Plan Admin") > -1 ||
                    this.role.indexOf("Broker Plan Manager") > -1 ||
                    this.role.indexOf("Documents Management Admin") > -1)
                );
              },
              title: "views.members.members_files",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "contact_page",
              buttons: [
                {
                  title: "views.members.manage",
                  action: () => {
                    this.$router.push({
                      name: "membersFiles",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              vif: () => {
                return (
                  this.useDocumentsManagement &&
                  (this.planIdentity.PlanType === "HW" ||
                    this.planIdentity.PlanType === "Pension") &&
                  (this.role.indexOf("Broker Plan Admin") > -1 ||
                    this.role.indexOf("Broker Plan Manager") > -1 ||
                    this.role.indexOf("Documents Management Admin") > -1 ||
                    this.role.indexOf("Employer Plan Admin") > -1)
                );
              },
              title: "components.employers.employer_details.employers_files",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "contact_page",
              buttons: [
                {
                  title: "views.members.manage",
                  action: () => {
                    this.$router.push({
                      name: "employersFiles",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "components.employers.employer_details.employers_uploads",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "contact_page",
              buttons: [
                {
                  title: "views.members.manage",
                  action: () => {
                    this.$router.push({
                      name: "planFiles",
                      params: {
                        planId: this.selectedPlan.Id,
                        mode: "employer",
                      },
                    });
                  },
                },
              ],
              vif: () =>
                this.useDocumentsManagement &&
                this.planIdentity.PlanType === "NoManaged" &&
                (this.role.indexOf("Broker Plan Admin") > -1 ||
                  this.role.indexOf("Broker Plan Manager") > -1 ||
                  this.role.indexOf("Documents Management Admin") > -1),
            },
          ],
        },
        {
          title: "components.vuematerialdashboard.core.drawer.portal",
          vif: () => {
            return (
              (this.planIdentity.PlanType === "HW" ||
                this.planIdentity.PlanType === "Pension") &&
              (this.planIdentity.HasDrupalPortal || this.planIdentity.Id === "3fac62fc-573d-4e6c-9fb4-c8d80075168f") &&
              this.planIdentity.MembersPortal &&
              this.planIdentity.MembersPortal.IsActive &&
              (this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Member Portal Admin") > -1)
            );
          },
          // title: "views.portal.download_center",
          icon: "web",
          tiles: [
            {
              title: "views.portal.theme_settings",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "palette",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "themeSettings",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "views.portal.contacts",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "email",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "portalContacts",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "views.portal.sidebar_items",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "vertical_split",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "sidebarItems",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "components.themesettings.banner",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "view_carousel",
              buttons: [
                {
                  title: "views.portal.configure",
                  action: () => {
                    this.$router.push({
                      name: "portalNews",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "views.portal.pages",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "file_copy",
              buttons: [
                {
                  title: "views.portal.manage_content",
                  action: () => {
                    this.$router.push({
                      name: "portalPages",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "views.portal.notifications",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "announcement",
              buttons: [
                {
                  title: "views.portal.configure",
                  action: () => {
                    this.$router.push({
                      name: "portalNotifications",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "views.portal.download_center",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "get_app",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "downloadCenter",
                      params: { planId: this.selectedPlan.Id, edit: true },
                    });
                  },
                },
              ],
            },
            {
              title: "views.portal.benefit_cards",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "credit_card",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "benefitCards",
                      params: {
                        planId: this.selectedPlan.Id,
                        edit: true,
                        cms: "old",
                      },
                    });
                  },
                },
              ],
            },
            {
              title: "views.portal.drugs_and_provider_index",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "local_hospital",
              buttons: [
                {
                  title: "views.portal.drug_list",
                  action: () => {
                    this.$router.push({
                      name: "drugs",
                      params: { planId: this.selectedPlan.Id, cms: "old" },
                    });
                  },
                },
                {
                  title: "views.portal.provider_list",
                  action: () => {
                    this.$router.push({
                      name: "providers",
                      params: { planId: this.selectedPlan.Id, cms: "old" },
                    });
                  },
                },
              ],
            },
            {
              title: "views.portal.suggestions_center",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "forum",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    // this.$router.push({
                    //   name: "downloadCenter",
                    //   params: { edit: true }
                    // });
                  },
                },
              ],
            },
            {
              title: "globals.coverage",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "security",
              buttons: [
                {
                  title: "views.portal.manage_content",
                  action: () => {
                    this.$router.push({
                      name: "portalCoverage",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
            },
            {
              title: "views.portal.welcome_kit",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "mail",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "welcomeKitNew",
                      params: {
                        planId: this.selectedPlan.Id,
                        edit: true,
                        cms: "new",
                      },
                    });
                  },
                },
              ],
            },
            // {
            //   title: "views.portal.images",
            //   color: this.$vuetify.theme.themes.light.secondary,
            //   icon: "square_foot",
            //   buttons: [
            //     {
            //       title: "components.vuematerialdashboard.core.drawer.view_edit",
            //       action: () => {
            //         this.$router.push({
            //           name: "images"
            //         });
            //       }
            //     }
            //   ]
            // }
          ],
        },
        {
          title: "components.vuematerialdashboard.core.drawer.portal",
          vif: () => {
            return (
              (!this.planIdentity.HasDrupalPortal || this.planIdentity.Id === "3fac62fc-573d-4e6c-9fb4-c8d80075168f") &&
              this.planIdentity.MembersPortal &&
              this.planIdentity.MembersPortal.IsActive &&
              (this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Member Portal Admin") > -1 ||
                this.role.indexOf("Member Portal Users Admin") > -1)
            );
          },
          icon: "web",
          tiles: [
            {
              title: "views.portal.portal_content",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "palette",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "portalContent",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
              vif: () =>
                this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Member Portal Admin") > -1,
            },
            {
              title: "views.portal.portal_configuration",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "settings",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "portalPlanSettings",
                      params: { planId: this.selectedPlan.Id },
                    });
                  },
                },
              ],
              vif: () =>
                this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Member Portal Admin") > -1,
            },
            {
              title: "views.portal.benefit_cards",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "credit_card",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "benefitCards",
                      params: {
                        planId: this.selectedPlan.Id,
                        edit: true,
                        cms: "new",
                      },
                    });
                  },
                },
              ],
              vif: () =>
                this.selectedPlan.PlanType === "HW" &&
                (this.role.indexOf("Broker Plan Manager") > -1 ||
                  this.role.indexOf("Member Portal Admin") > -1),
            },
            {
              title: "views.portal.drugs_and_provider_index",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "local_hospital",
              buttons: [
                {
                  title: "views.portal.drug_list",
                  action: () => {
                    this.$router.push({
                      name: "drugs",
                      params: { planId: this.selectedPlan.Id, cms: "new" },
                    });
                  },
                },
                {
                  title: "views.portal.provider_list",
                  action: () => {
                    this.$router.push({
                      name: "providers",
                      params: { planId: this.selectedPlan.Id, cms: "new" },
                    });
                  },
                },
              ],
              vif: () =>
                this.selectedPlan.PlanType === "HW" &&
                (this.role.indexOf("Broker Plan Manager") > -1 ||
                  this.role.indexOf("Member Portal Admin") > -1),
            },
            {
              title: "views.portal.welcome_kit",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "mail",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "welcomeKitNew",
                      params: { planId: this.selectedPlan.Id, cms: "new" },
                    });
                  },
                },
              ],
              vif: () =>
                this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Member Portal Admin") > -1,
            },
            {
              title: "views.portal.users_management",
              vif: () => {
                return this.selectedPlan.PlanType === "NoManaged";
              },
              color: "#007cb5",
              icon: "group",
              buttons: [
                {
                  title:
                    "components.vuematerialdashboard.core.drawer.view_edit",
                  action: () => {
                    this.$router.push({
                      name: "usersManagement",
                      params: { planId: this.selectedPlan.Id, cms: "new" },
                    });
                  },
                },
              ],
            },
          ],
        },
        {
          title: "components.vuematerialdashboard.core.appbar.claims",
          vif: () => {
            return (
              ((!this.selectedPlan.UseISeriesClaims &&
                this.planIdentity.PlanType === "HW") ||
                this.planIdentity.PlanType === "Pension") &&
              this.role.indexOf("Claims Administrator") > -1
            );
          },
          icon: "medical_services",
          tiles: [
            {
              title: "components.claims_history.tab.submitted",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "medical_services",
              buttons: [
                {
                  title: "views.members.manage",
                  action: () => {
                    this.$router.push({
                      name: "claimsTable",
                    });
                  },
                },
              ],
            },
            {
              title:
                "components.vuematerialdashboard.core.appbar.claims_payments",
              color: "rgb(0, 124, 181)",
              icon: "medical_services",
              buttons: [
                {
                  title: "globals.view",
                  action: () => {
                    this.$router.push({
                      name: "claimsPayments",
                    });
                  },
                },
                {
                  title: "views.billing.archive",
                  action: () => {
                    this.$router.push({
                      name: "claimsReports",
                    });
                  },
                },
              ],
            },
            // {
            //   title: "components.vuematerialdashboard.core.appbar.claims_payments",
            //   color: this.$vuetify.theme.themes.light.secondary,
            //   icon: "attach_money",
            //   buttons: [
            //     {
            //       title: "components.vuematerialdashboard.core.drawer.view_edit",
            //       action: () => {
            //         this.$router.push({
            //           name: "claimsPayments"
            //         });
            //       },
            //     },
            //   ],
            // },
          ],
        },
        {
          title: "Opt Outs",
          vif: () => {
            console.log("esto es", this.payload);
            return (
              !this.planIdentity.HasDrupalPortal &&
              this.planIdentity.MembersPortal &&
              this.payload.Json.canOptout &&
              this.planIdentity.MembersPortal.IsActive &&
              (this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Member Portal Admin") > -1 ||
                this.role.indexOf("Member Portal Users Admin") > -1)
            );
          },
          icon: "medical_services",
          tiles: [
            {
              title: "Opt out settings",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "medical_services",
              buttons: [
                {
                  title: "globals.view",
                  action: () => {
                    this.$router.push({ name: "opt-out-settings" });
                  },
                },
              ],
            },
            {
              title: "Opt outs List",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "medical_services",
              buttons: [
                {
                  title: "globals.view",
                  action: () => {
                    this.$router.push({ name: "opt-outs-list" });
                  },
                },
              ],
            },
            {
              title: "Reimbursements",
              color: this.$vuetify.theme.themes.light.secondary,
              icon: "medical_services",
              buttons: [
                {
                  title: "globals.view",
                  action: () => {
                    this.$router.push({ name: "opt-out-reimbursements" });
                  },
                },
              ],
            },
          ],
        },
      ],
      sickDayWarning: false,
      noSickDaySettings: false,
    };
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planOptions", "planIdentity"]),
    useDocumentsManagement() {
      var settings = SettingsService.settings;
      // console.log("useDocumentsManagement", settings.UseDocumentsManagement);
      return settings.UseDocumentsManagement;
    },
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  async mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", ["getPlanSickBankSettings"]),
    ...mapActions("portalsProxy", ["getPlanPortalConfiguration"]),
    async loadPlanData() {
      try {
        const item = (
          await this.getPlanPortalConfiguration({
            planIdentityId: this.selectedPlan.Id,
          })
        ).data;
        if (item !== null && item !== undefined && item != "") {
          this.payload = item; //JSON.stringify(item, null, 2);
          this.payload.UseLegacyClaims = this.selectedPlan.UseISeriesClaims;
        } else {
          this.payload = {
            Json: {},
          };
        }
      } catch (error) {
        console.log(error);
      }
    },
    async loadSickBankSettings() {
      if (this.planIdentity.HasSickPaymentBank) {
        let sickDaySettings = (
          await this.getPlanSickBankSettings({
            planIdentityId: this.planIdentity.Id,
          })
        ).data;
        if (
          sickDaySettings === null ||
          sickDaySettings === undefined ||
          sickDaySettings === ""
        ) {
          this.noSickDaySettings = true;
        }
      }
    },
    async bulkHoursClick() {
      await this.loadSickBankSettings();
      console.log("hour click: ", this.noSickDaySettings);
      if (this.noSickDaySettings === true) {
        this.sickDayWarning = true;
      } else {
        console.log("hour click: wtf", this.noSickDaySettings);
        this.$router.push({
          name: "hoursImportWizard",
          params: { planId: this.selectedPlan.Id },
        });
      }
    },
  },
};
</script>

<style>
.row.match-my-cols {
  overflow: hidden;
}

.row.match-my-cols [class*="col-"] {
  margin-bottom: -99999px;
  padding-bottom: 99999px;
}

.row.match-my-cols .v-card {
  height: 100%;
}

[class*="col-"] {
  padding: 14px 7px 14px 7px;
}
.v-card__title h4 {
  color: #36454f;
  font-weight: 300;
  font-size: 1.125rem;
  margin-left: 4px;
}
</style>
